// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/7/22
// +-------------------------------------------------------------
// |Time: 15:48
// +-------------------------------------------------------------
import {is_android_h5, is_android_sdk, is_ios_h5} from "@/utils/devices";
import {openUrl, sendMessage} from "@/utils/callback";
import {showToast} from "vant";
import {getItem} from "@/utils/storage";
export const VersionMatchHandle = {
    getIdsData(name){
        if (is_android_sdk()) {
            return window.and_youliang.getData(name) || 0
        } else if(is_ios_h5()){
            window.webkit.messageHandlers.ulGetParams.postMessage(JSON.stringify({name}))
        } else {
            let query = self != top ? window.name : window.location.href;
            name = name == "game_id" ? 'gid' : 'pid';
            if (query.indexOf(name) > -1){
                let vars = query.substring(query.indexOf(name));
                let paramArr = vars.split("/");
                let varsArr = paramArr[0].split("_");
                return varsArr[1]
            }
        }
        return 0
    },
    getStoreData(name){
        if (is_android_sdk()) {
            return window.and_youliang.getData(name) || 0
        } else if(is_ios_h5()){
            window.webkit.messageHandlers.ulGetParams.postMessage(JSON.stringify({name}))
        }else if(is_android_h5()){
            try{
                return window.youliang_h5.getData(name)
            }catch {
                return getItem(name)
            }
        }else{
            return getItem(name)
        }
    },
    sendPayResult(status, cpOrder){
        if (is_android_sdk()) {
            window.and_youliang.GetPayResult(status, cpOrder)
        } else if(is_ios_h5()){
            window.webkit.messageHandlers.ulPayResults.postMessage(JSON.stringify({status,cpOrder}))
        } else {
            const defaults = {
                action: "payCallback",
                status: status,
                cpOrder: cpOrder,
            };
            sendMessage(defaults)
        }
    },
    closeOpenUrl(){
        if (is_android_sdk()) {
            window.and_youliang.FinishWebview()
        } else if(is_ios_h5()){
            window.webkit.messageHandlers.ulCloseWeb.postMessage('')
        } else {
            openUrl('')
        }
    },
    userEditConfig(type,status){
        if (is_android_sdk()) {
            window.and_youliang.Derail(type,status)
        } else if(is_ios_h5()){
            window.webkit.messageHandlers.ulEditConfig.postMessage(JSON.stringify({type,status}))
        } else {
            const defaults = {
                action: type == 1 ?"setAutoLoginCallback" : "setFloatCallback",
                status
            };
            sendMessage(defaults)
        }
    },
    OpenBrowser(url){
        try {
            if (is_android_sdk()) {
                window.and_youliang.OpenWebviewToBrowser(url)
            } else if(is_ios_h5()){
                window.webkit.messageHandlers.ulOpenBrowser.postMessage(JSON.stringify({url}))
            } else {
                top.open(url)
            }
        }catch (e){
            showToast("打开失败，请复制到浏览器打开")
        }

    }
}
